// SelectCorporate.tsx
import { useState, useEffect } from "react";
import { useFetchCorporateListQuery } from "@features/corporateSelection/corporateSelectAPI";
import CorporateList from "@features/corporateSelection/corporateList/CorporateList";


const SelectCorporate = () => {
  // ==================== State Management ====================
  const [page, setPage] = useState(1);
  const [corporates, setCorporates] = useState<any[]>([]);
  const [hasMore, setHasMore] = useState(true);

  // ==================== API Query ====================
  const { data, isLoading, isFetching } = useFetchCorporateListQuery({ page });

  useEffect(() => {
    if (data?.data) {
      // Append new corporates to the list
      setCorporates((prev) => [...prev, ...data.data]);

      // Check if more pages exist
      setHasMore(!!data.next);
    }
  }, [data]);

  // ==================== Event Handlers ====================
  /**
   * Loads next page of corporates
   * Called by InfiniteScroll when user scrolls to bottom
   */
  const fetchMoreData = () => {
    if (!isFetching && hasMore) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  return (
    <CorporateList
      corporates={corporates}
      isLoading={isFetching}
      fetchMoreData={fetchMoreData}
      dataLength={corporates.length}
      hasMore={hasMore}
      loading={isLoading}
    />
  );
};

export default SelectCorporate;
